import { Tooltip, TableCell, Typography } from '@mui/material';

import { htmlToText } from 'src/utils/commonUtils';

import { truncateText } from 'src/pages/chat/utils/text-formatting';

// ----------------------------------------------------------------------

type Props = {
  value: string;
  maxLength?: number;
  parseHtml?: boolean;
  transformValue?: (value: string) => string;
  headerIndex?: number;
  cellKey?: string;
};

// ----------------------------------------------------------------------

export function RowCellText({
  value,
  maxLength = 50,
  parseHtml = false,
  transformValue,
  headerIndex,
  cellKey,
}: Props) {
  // Parse HTML if needed
  let displayValue = parseHtml ? htmlToText(value) : value;

  // Apply transformation if provided (e.g., replace underscores)
  if (transformValue) {
    displayValue = transformValue(displayValue);
  }

  const shouldTruncate = displayValue && displayValue.length > maxLength;
  const truncatedValue = shouldTruncate ? truncateText(displayValue, maxLength) : displayValue;

  return (
    <TableCell key={cellKey || headerIndex}>
      {shouldTruncate ? (
        <Tooltip title={displayValue}>
          <Typography
            variant="body2"
            sx={{
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                color: 'primary.main',
              },
            }}
          >
            {truncatedValue}
          </Typography>
        </Tooltip>
      ) : (
        <Typography variant="body2">{displayValue}</Typography>
      )}
    </TableCell>
  );
}
